module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-BoldItalic.9bce1501.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-BoldItalic.ttf
// module id = 529
// module chunks = 0